import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";

import { ThemeProvider as MuiThemeProvider, THEME_ID } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import calfTheme from "theme/muiTheme";

import { ChakraProvider } from "@chakra-ui/react";
import chakraTheme from "theme/theme.js";

import { AuthProvider } from "./AuthProvider.js";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ExportProvider } from 'context/ExportContext';
import ExportSnackbar from 'components/ExportSnackbar/ExportSnackbar';

const root = document.getElementById("root");
const reactRoot = createRoot(root);

reactRoot.render(
  <MuiThemeProvider theme={{ [THEME_ID]: calfTheme }}>
    <CssBaseline />
    <ExportProvider>
      <ChakraProvider theme={chakraTheme} resetCss={false}>
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          language="es"
          useRecaptchaNet={true}
          useEnterprise={false}
          scriptProps={{
            async: false,
            defer: false,
            appendTo: "head",
            nonce: undefined,
          }}
        >
          <HashRouter>
            <AuthProvider>
              <Switch>
                <Route path={`/auth`}  component={AuthLayout} />
                <Route path={`/admin`} component={AdminLayout} />
                <Redirect from={`/`} to="/admin/dashboard" />
              </Switch>
            </AuthProvider>
          </HashRouter>
        </GoogleReCaptchaProvider>
      </ChakraProvider>
      <ExportSnackbar />
    </ExportProvider>
  </MuiThemeProvider>
);
